import React, { Component } from "react";
import { Tooltip } from "@material-ui/core";
import Image from "../Image";

export class Input extends Component {
  render() {
    const {
      name,
      image,
      image2,
      height,
      placeholder,
      isShowError,
      inputref,
      label,
      bordercolor,
      isShowPasswordError,
      onClick,
      type,
      errorMessage,
      copyOnclick,
      shareOnclick,
      tooltip,
      isMandatory,
      width,
      ...rest
    } = this.props;
    return (
      <div style={{ width: this.props.width || "" }}>
        <div className="input-name">
          {name} {label}
          {isMandatory && <span className="mandatory"> *</span>}
          {!!tooltip && (
            <Tooltip title={tooltip} arrow>
              <Image
                src={"/images/information.png"}
                alt="info"
                style={{ height: "15px", marginLeft: "10px" }}
              />
            </Tooltip>
          )}
          {!!this.props.link && (
            <span
              style={{
                textDecoration: "underline",
                color: "#194b7e",
                fontSize: 13,
                cursor: "pointer",
              }}
              onClick={this.props.linkClicked}
            >
              {this.props.linkText}
            </span>
          )}
        </div>
        <div
          className="Input-field-div"
          style={{
            borderColor:
              isShowError || isShowPasswordError
                ? "red"
                : !!bordercolor
                  ? bordercolor
                  : "#a6a6a6",
          }}
        >
          {!!image && (
            <Image
              src={`${image}`}
              alt="input-label"
              style={{ height: 20, marginRight: 15 }}
            />
          )}

          {name?.includes("ARN") || name?.includes("Broker") ? (
            <label className="arn_label">ARN -</label>
          ) : name?.includes("EUIN") || name?.includes("Broker") ? (
            <label className="arn_label">E</label>
          ) : name?.includes("NSDL") || name?.includes("NSDL ID") ? (
            <label className="arn_label">IN</label>
          ) : (
            ""
          )}
          <input
            className="input-without-arn-label number-input"
            placeholder={placeholder}
            autoComplete="off"
            ref={inputref}
            onKeyDown={this.props.onKeyDown}
            onBlur={this.props.onBlur}
            type={type || "text"}
            step={this.props.step}
            disabled={this.props.disabled}
            onMouseOver={type === "number" ? (e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false }) : null}

            {...rest}
          />

          <div
            onClick={this.props.onClick}
            style={{
              minWidth: 70,
              minHeight: 48,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {!!this.props.copyimage && (
              <Image
                src={this.props.copyimage}
                alt="field_image"
                height={20}
                style={{ cursor: "pointer", marginLeft: 10 }}
                onClick={this.props.copyOnclick}
              />
            )}
            {!!this.props.shareimage && (
              <Image
                src={this.props.shareimage}
                alt="field_image"
                style={{ cursor: "pointer", marginLeft: 10 }}
                height={20}
                onClick={this.props.shareOnclick}
              />
            )}
            {!!image2 && (
              <Image
                src={`${image2}`}
                alt="field_image"
                height={15}
              />
            )}
          </div>
        </div>
        <div style={{ color: "red", fontFamily: "Rubik-Italic" }}>
          {isShowError
            ? errorMessage || ` is required.`
            : isShowPasswordError
              ? "Password shoould be atleast 8 characters in length and should contain at least 1 Upper Case alphabet(A-Z).1 Special Character and 1 Numeric Value (0-9)"
              : ""}
        </div>
      </div>
    );
  }
}

export class OtpInput extends Component {
  render() {
    const { inputref, ...rest } = this.props;
    return (
      <div>
        <input
          className="otp_input number-input"
          type="number"
          style={{ textAlign: "center" }}
          ref={inputref}
          {...rest}
        />
      </div>
    );
  }
}
